<script setup lang="ts">
    import type {ActiveFilter} from './chatApi';

    defineProps<{
        filters: ActiveFilter[];
        disabled: boolean;
    }>();

    const emit = defineEmits<{(event: 'remove', filter: ActiveFilter): void}>();
</script>

<template>
    <div
        class="chat-pills filters"
        aria-label="Actieve filters">
        <span class="text-muted">Actieve filters:</span>
        <button
            v-for="filter in filters"
            :key="filter.facetKey"
            type="button"
            class="btn btn-default btn-sm"
            :disabled="disabled"
            :aria-label="`Verwijder filter ${filter.label}`"
            @click="emit('remove', filter)">
            <span>{{ filter.label }}: {{ filter.values.join(', ') }}</span>
            <span
                style="padding-left: 4px"
                aria-hidden="true">
                &times;
            </span>
        </button>
    </div>
</template>

<style scoped>
    /* Lines up with the assistant's cards: the transcript's own padding plus the avatar indent.
       Both come from the tokens, so this no longer hides a hand-added 24 + 42. */
    .filters {
        align-items: center;
        padding: 10px var(--chat-pad) 0 calc(var(--chat-pad) + var(--chat-indent));
    }
</style>
